import img1 from "./images/Image Blog 1.png";
import img2 from "./images/Image Blog 2.png";
import img3 from "./images/Image Blog 3.png";

const Blogdata = [
    {
        id: 1,
        blogimg: img1,
        timestamp: "23 Nov, 2023 / Cheesecake",
        title: "A Peek Behind the Cheesecake Curtain",
        content: "Step into our cheesecake haven, where the magic unfolds behind the scenes, whisking dreams into reality. Our kitchen is a symphony and very..."
    },
    {
        id: 2,
        blogimg: img2,
        timestamp: "18 July, 2023 / Cheesecake",
        title: "Low-Sugar & Gluten-Free Cheesecakes",
        content: "Welcome to our guilt-free indulgence zone, where we're redefining the art of cheesecake with our delectable low-sugar..."
    },
    {
        id: 3,
        blogimg: img3,
        timestamp: "1 January, 2024 / Cheesecake",
        title: "Sweet Words - Customer Reviews of Cheesecakes",
        content: "Indulge in the rich tapestry of heartfelt stories within Sweet Words. This curated collection of customer reviews offers a glimpse into the joy..."
    }
];
export default Blogdata;